<template>
  <button
    :class="clsx('ui-button', {
      'ui-button--loading': isLoading,
      'ui-button--disabled': isDisabled || isLoading,
      [`ui-button--size-${size}`]: true
    })"
    :disabled="isDisabled || isLoading"
    v-on="$listeners"
  >
    <span class="ui-button__content" v-if="!isLoading">
      <slot />
    </span>
    <span class="ui-button__loader" v-if="isLoading">
      <SpinnerLoader />
    </span>
  </button>
</template>

<script>
import { clsx } from 'clsx';
import { SpinnerLoader } from '@/shared/ui/loader';

export default {
  components: { SpinnerLoader },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'small', 'large'].includes(value),
    },
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.ui-button {
   font-family: "IBM Plex Sans", sans-serif;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   font-weight: 600;
   color: #FFFFFF;
   border-radius: 16px;
   background: rgba(49, 52, 55, 0.5);
   padding: 10px 24px;
   font-size: 16px;
   cursor: pointer;
   transition: background-color 0.2s ease, color 0.2s ease;
   white-space: nowrap;
}

.ui-button:hover:not(:disabled) {
  background-color: rgba(49, 52, 55, 0.7);
  color: rgba(255, 255, 255, 0.85);
}

.ui-button:active:not(:disabled) {
  background-color: rgba(49, 52, 55, 0.9);
  opacity: 1;
}

.ui-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 52, 55, 0.4);
}

.ui-button--size-default {
  padding: 10px 24px;
  font-size: 14px;
}

.ui-button--size-small {
  padding: 8px 16px;
  font-size: 12px;
}

.ui-button--size-large {
  padding: 12px 28px;
  font-size: 16px;
}

.ui-button:disabled,
.ui-button--disabled {
  cursor: not-allowed;
  pointer-events: none;
  background-color: rgba(49, 52, 55, 0.25);
  color: rgba(255, 255, 255, 0.4);
}

.ui-button--loading {
  .ui-button__content {
    visibility: hidden;
  }
  .ui-button__loader {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.ui-button__loader {
  display: flex;
  align-items: center;
  margin-left: 8px;
}
</style>
